"use strict";
/** Normalização e apresentação de texto. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.slugify = slugify;
exports.toDisplayName = toDisplayName;
exports.initials = initials;
exports.normalizeWhitespace = normalizeWhitespace;
exports.normalizeEmail = normalizeEmail;
exports.normalizePhone = normalizePhone;
exports.formatPhoneBR = formatPhoneBR;
exports.truncate = truncate;
exports.pluralize = pluralize;
/** Remove acentos e caracteres não-alfanuméricos: "Pelada do Douglas" → "pelada-do-douglas". */
function slugify(value) {
    return value
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 60);
}
/**
 * Nome de exibição reduzido: "João Pedro da Silva" → "João S.".
 * Usado em listas públicas para não expor o nome completo desnecessariamente.
 */
function toDisplayName(fullName) {
    const parts = fullName.trim().split(/\s+/).filter(Boolean);
    const first = parts[0] ?? '';
    const last = parts.length > 1 ? parts[parts.length - 1] : undefined;
    return last ? `${first} ${last.charAt(0).toUpperCase()}.` : first;
}
function initials(fullName) {
    const parts = fullName.trim().split(/\s+/).filter(Boolean);
    const first = parts[0]?.charAt(0) ?? '';
    const last = parts.length > 1 ? (parts[parts.length - 1]?.charAt(0) ?? '') : '';
    return (first + last).toUpperCase() || '?';
}
/** Colapsa espaços e remove caracteres de controle. */
function normalizeWhitespace(value) {
    return value.replace(/\p{Cc}/gu, '').replace(/\s+/g, ' ').trim();
}
/** E-mail canônico para comparação/unicidade: minúsculas e sem espaços. */
function normalizeEmail(email) {
    return email.trim().toLowerCase();
}
/** Telefone só com dígitos, com DDI 55 quando o número parece brasileiro. */
function normalizePhone(phone) {
    const digits = phone.replace(/\D/g, '');
    if (digits.length === 10 || digits.length === 11)
        return `55${digits}`;
    return digits;
}
/** Formata telefone brasileiro: "5511987654321" → "(11) 98765-4321". */
function formatPhoneBR(phone) {
    const digits = phone.replace(/\D/g, '').replace(/^55/, '');
    if (digits.length === 11)
        return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
    if (digits.length === 10)
        return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
    return phone;
}
function truncate(value, max) {
    return value.length <= max ? value : `${value.slice(0, max - 1).trimEnd()}…`;
}
function pluralize(count, singular, plural) {
    return count === 1 ? singular : plural;
}
//# sourceMappingURL=text.js.map